<template>
  <span class="spinner" />
</template>

<style scoped>
  .spinner {
    display: block;
    width: 36px;
    height: 36px;
    border: 2px solid var(--sf-base-border-secondary); 
    border-top-color: var(--sf-base-border-dark); 
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>